'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175() {
  this.ceL = null;
  this.ceJ = null;
  this.ceK = false;
  this.ceH = null;
  this.ceI = false;
  this.ceM = false;
  this.ceN = false;
  this.ceL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175 as $c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175 };
$p = $c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175;
/** @constructor */
function $h_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175() {
}
export { $h_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175 as $h_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175 };
$h_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.ceL;
});
$p.t = (function() {
  if ((!this.ceK)) {
    this.ceJ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("secret", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.ceK = true;
  }
  return this.ceJ;
});
$p.ad = (function() {
  if ((!this.ceI)) {
    this.ceH = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.ceI = true;
  }
  return this.ceH;
});
$p.v = (function() {
  if ((!this.ceN)) {
    this.ceM = false;
    this.ceN = true;
  }
  return this.ceM;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175, "presto.types$proto$StoreTwoFactorAuthRequestPayload$$anon$175", ({
  a41: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175 as $d_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175 };
//# sourceMappingURL=presto.types$proto$-Store-Two-Factor-Auth-Request-Payload$$anon$175.js.map
